import { useEffect, useMemo, useState } from "react";
import Reports from "./Reports";
import WorkInProgress from "./WorkInProgress";
import TabItems from "../../../core/common/TabItems";
import Footer from "../../../core/common/Footer";
import useApi from "../../../core/customhook/useApi";
import { PageLoader } from "../../../core/common/loader/PageLoader";

// Strict type
type TabLabel =
  // | "Application Submitted"
  | "Work In Progress"
  // | "Interim Reports"
  | "All Reports";

type TabItem = {
  status_id: string;
  label: TabLabel;
  count: number;
};

// FIX: Store COMPONENT, not JSX
const componentMap: Record<TabLabel, React.ComponentType<any>> = {
  // "Application Submitted": ApplicationSubmitted,
  "Work In Progress": WorkInProgress,
  // "Interim Reports": InterimReports,
  "All Reports": Reports,
};

const TrackCaseProgram = () => {
  const { data: tabCount, loading } = useApi(
    "/api/v1/agency/manager-live-case-progress-count",
    {
      method: "GET",
      autoCall: true,
    },
  );

  //  Build tabs with Component reference
  const dynamicTabs =
    (tabCount?.data as TabItem[] | undefined)?.map((item) => ({
      id: item?.label,
      status_id: item?.status_id ?? "",
      label: item?.label,
      count: item?.count,
      Component: componentMap[item.label], //  correct
    })) ?? [];

  const [activeTab, setActiveTab] = useState<string>("");

  useEffect(() => {
    if (dynamicTabs.length > 0 && !activeTab) {
      setActiveTab(dynamicTabs[0].label);
    }
  }, [dynamicTabs]);

  useEffect(() => {
    const storedTab = localStorage.getItem("manager-active-track-case-tab");
    if (storedTab) {
      setActiveTab(storedTab);
    }
  }, []);

  const activeTabData = dynamicTabs?.find((tab) => tab.label === activeTab);

  return (
    <div className="page-wrapper">
      {loading ? (
        <PageLoader />
      ) : (
        // <SnipperLoader />
        <div className="content p-2 p-md-3">
          <TabItems
            tabList={dynamicTabs}
            activeTab={activeTab}
            handleClick={(d) => {
              setActiveTab(d.label);
              localStorage.setItem("manager-active-track-case-tab", d.label);
            }}
          />

          <div className="mt-3">
            {/* Render component with status_id */}
            {activeTabData?.Component && (
              <activeTabData.Component status_id={activeTabData?.status_id} />
            )}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default TrackCaseProgram;
